import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'
import { addToast } from 'containers/Toasts/actions'

import {
  getAnnouncementsLogoError,
  getAnnouncementsLogoSuccess,
  submitAnnouncementsLogoError,
  submitAnnouncementsLogoSuccess,
} from './actions'
import { GET_ANNOUNCEMENTS_LOGO_ASYNC, SUBMIT_ANNOUNCEMENTS_LOGO_ASYNC } from './constants'

const fetchAnnouncementsLogoEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS, GET_ANNOUNCEMENTS_LOGO_ASYNC.INITIATE),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.endUserAlerts)
      return true
    }),
    mergeMap(() =>
      api.settings
        .getAnnouncementsLogo(
          state$.value.partnerOptions.selectedCompany?.value || state$.value.app.data.id
        )
        .pipe(
          map((response) => getAnnouncementsLogoSuccess(response)),
          catchError((error) => of(epicsErrorHandler(getAnnouncementsLogoError, error))),
          takeUntil(action$.pipe(ofType(GET_ANNOUNCEMENTS_LOGO_ASYNC.CANCEL)))
        )
    )
  )

const submitAnnouncementsLogoEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(SUBMIT_ANNOUNCEMENTS_LOGO_ASYNC.INITIATE),
    mergeMap(() =>
      api.settings
        .updateAnnouncementsLogo(state$.value.partnerOptions.selectedCompany?.value, {
          notificationsLogoTemplate:
            state$.value.settings.notifications.logo.data?.notificationsLogoTemplate,
        })
        .pipe(
          mergeMap((response) =>
            of(submitAnnouncementsLogoSuccess(response), addToast({ message: 'Updated!' }))
          ),
          catchError((error) => of(epicsErrorHandler(submitAnnouncementsLogoError, error))),
          takeUntil(action$.pipe(ofType(SUBMIT_ANNOUNCEMENTS_LOGO_ASYNC.CANCEL)))
        )
    )
  )

export default combineEpics(fetchAnnouncementsLogoEpic, submitAnnouncementsLogoEpic)
